import { FC } from "react";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Combobox } from "@/components/Interface/FormFields/Combobox/Combobox";
import { CardModule } from "@/components/Layout/BaseLayouts/CardModule/CardModule";
import { BillingAccountChip } from "@/components/Portal/Documents/BillingAccounts/BillingAccountChip";
import { getBillingAccountDisplayValue } from "@/components/Portal/Documents/BillingAccounts/billingAccountUtils";
import { DrAccount } from "@/services/model";

import { BulkMoveFormValues } from "./bulkMoveFormValues";

interface Props {
  /** Every Vertragskonto except the source. */
  targets: DrAccount[];
  selectedCount: number;
  control: Control<BulkMoveFormValues>;
  disabled?: boolean;
}

/** "2. Ziel-Rechnungsempfänger": the Vertragskonto the Abos move to. */
export const TargetSelection: FC<Props> = ({
  targets,
  selectedCount,
  control,
  disabled,
}) => {
  const { t } = useTranslation("portal", {
    keyPrefix: "user-account.billingAccounts.bulkMove",
  });
  const { t: tPortal } = useTranslation("portal");

  return (
    <CardModule
      dataTestid="bulk-move-target"
      variant="white"
      title={t("targetHeadline")}
      description={t("targetDescription")}
    >
      <div className="flex items-center gap-2">
        <p className="truncate text-body-base font-semibold leading-md text-foreground-primary">
          {t("selected")}
        </p>
        <BillingAccountChip text={selectedCount} />
      </div>
      <Controller
        control={control}
        name="target"
        render={({ field }) => (
          <Combobox<DrAccount>
            dataTestId="bulk-move-target-select"
            field={field}
            label={tPortal("user-account.billingAccounts.move.target")}
            displayValue={getBillingAccountDisplayValue}
            options={targets}
            placeholder={tPortal("user-account.billingAccounts.move.target")}
            disabled={disabled}
          />
        )}
      />
    </CardModule>
  );
};
